import common from './common';
import sizes from './sizes';
import tabIdentifiers from './tab-identifiers';
import fieldNames, {
  FIELD_NAMES_IN_GENERAL_TAB,
  FIELD_NAMES_IN_SEO_TAB,
  FIELD_NAMES_IN_OPEN_GRAPH_TAB,
  FIELD_NAMES_IN_CUSTOM_CODE_TAB,
} from './field-names';

export default {
  common,
  sizes,
  tabIdentifiers,
  fieldNames,
  FIELD_NAMES_IN_GENERAL_TAB,
  FIELD_NAMES_IN_SEO_TAB,
  FIELD_NAMES_IN_OPEN_GRAPH_TAB,
  FIELD_NAMES_IN_CUSTOM_CODE_TAB,
};
